import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuthService } from 'src/app/auth-module/services/auth.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnChanges {

  facility_name = '';
  cse_name = '';
  state_name = '';
  stateList = [];
  payment_status = '';
  paymentStatusList = ['Completed', 'Partially Completed', 'Pending For Approval', 'Pending', 'Rejected'];
  payment_status_params = '';
  params: string = '';
  lead_dr_name = '';

  @Input() componentName;
  @Output() filterParams = new EventEmitter<any>();

  constructor(private authService: AuthService) {
    if (sessionStorage.getItem('isClearFilter') == 'true') {
      sessionStorage.removeItem('search_facility_name');
      sessionStorage.removeItem('filter_facility_name');
      sessionStorage.removeItem('filter_cse_name');
      sessionStorage.removeItem('filter_state_name');
      sessionStorage.removeItem('filter_payment_status');
      sessionStorage.removeItem('filter_lead_dr_name');
    }
  }

  ngOnInit(): void {
    if(this.componentName == 'facilityListing'){
      this.getStateList();
    }
    this.prefill();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes', changes);
  }

  getStateList() {
    this.authService.stateList().subscribe((response: any) => {
      this.stateList = response?.states;
    })
  }

  prefill() {
    if (sessionStorage.getItem('filter_facility_name') !== null || sessionStorage.getItem('filter_cse_name') !== null || sessionStorage.getItem('filter_state_name') !== null || sessionStorage.getItem('filter_payment_status') !== null || sessionStorage.getItem('filter_lead_dr_name') !== null) {
      this.facility_name = sessionStorage.getItem('filter_facility_name') !== null ? sessionStorage.getItem('filter_facility_name') : '';
      this.cse_name = sessionStorage.getItem('filter_cse_name') !== null ? sessionStorage.getItem('filter_cse_name') : '';
      this.state_name = sessionStorage.getItem('filter_state_name') !== null ? sessionStorage.getItem('filter_state_name') : ''
      this.payment_status_params = sessionStorage.getItem('filter_payment_status') !== null ? sessionStorage.getItem('filter_payment_status') : '';
      this.lead_dr_name = sessionStorage.getItem('filter_lead_dr_name') !== null ? sessionStorage.getItem('filter_lead_dr_name') : '';
      
      //To Prefill Input/Dropdown values
      if (sessionStorage.getItem('filter_facility_name') !== null) {
        this.facility_name = sessionStorage.getItem('filter_facility_name');
      }
      if (sessionStorage.getItem('filter_cse_name') !== null) {
        this.cse_name = sessionStorage.getItem('filter_cse_name');
      }
      if (sessionStorage.getItem('filter_state_name') !== null) {
        this.state_name = sessionStorage.getItem('filter_state_name');
      }
      if(sessionStorage.getItem('filter_lead_dr_name') !== null){
        this.lead_dr_name = sessionStorage.getItem('filter_lead_dr_name');
      }
      
      // Auto Select For Filter Payment Status
      if (sessionStorage.getItem('filter_payment_status') !== null) {
        let payment_status_params = sessionStorage.getItem('filter_payment_status');
        if (payment_status_params == 'status=2&is_payment=true') {
          this.payment_status = 'Completed';
        } else if (payment_status_params == 'status=2&is_payment=false') {
          this.payment_status = 'Partially Completed';
        } else if (payment_status_params == 'status=1') {
          this.payment_status = 'Pending For Approval';
        } else if (payment_status_params == 'payment=null') {
          this.payment_status = 'Pending';
        } else if (payment_status_params == 'status=3') {
          this.payment_status = 'Rejected';
        }
      }
      sessionStorage.removeItem('search_facility_name');   // To Remove Searched Data (Placed left side of filter button)

      let filterValue = {
        facility_name: this.facility_name ? this.facility_name : '',
        cse_name: this.cse_name ? this.cse_name : '',
        state_name: this.state_name ? this.state_name : '',
        payment_status_params: this.payment_status_params ? this.payment_status_params : '',
        lead_dr_name: this.lead_dr_name ? this.lead_dr_name : '',
      }

      this.filterParams.emit(filterValue);
    }
  }

  paymentStatusChange(value) {
    if (value == 'Completed') {
      this.payment_status_params = `status=2&is_payment=true`;     //Required by backend to filter
    } else if (value == 'Partially Completed') {
      this.payment_status_params = `status=2&is_payment=false`;
    } else if (value == 'Pending For Approval') {
      this.payment_status_params = `status=1`;
    } else if (value == 'Pending') {
      this.payment_status_params = `payment=null`;
    } else if (value == 'Rejected') {
      this.payment_status_params = `status=3`;
    } else if (value == "") {
      this.payment_status_params = '';
    }
  }

  filterEnterClick(event) {
    if (event.key === 'Enter') {
      console.log('enter');
      this.searchFilterClick();
    }
  }

  searchFilterClick() {
    sessionStorage.setItem('filter_facility_name', this.facility_name);
    sessionStorage.setItem('filter_cse_name', this.cse_name);
    sessionStorage.setItem('filter_state_name', this.state_name);
    sessionStorage.setItem('filter_payment_status', this.payment_status_params);
    sessionStorage.setItem('filter_lead_dr_name', this.lead_dr_name)

    let filterValue = {
      facility_name: this.facility_name ? this.facility_name : '',
      cse_name: this.cse_name ? this.cse_name : '',
      state_name: this.state_name ? this.state_name : '',
      payment_status_params: this.payment_status_params ? this.payment_status_params : '',
      lead_dr_name: this.lead_dr_name ? this.lead_dr_name : '',
    }
    sessionStorage.removeItem('search_facility_name');
    this.filterParams.emit(filterValue);
  }

  resetFilterClick() {
    this.facility_name = '';
    this.cse_name = '';
    this.state_name = '';
    this.payment_status = '';
    this.payment_status_params = '';
    this.lead_dr_name = '';
    sessionStorage.removeItem('filter_facility_name');
    sessionStorage.removeItem('filter_cse_name');
    sessionStorage.removeItem('filter_state_name');
    sessionStorage.removeItem('filter_payment_status');
    sessionStorage.removeItem('filter_lead_dr_name')

    let filterValue = {
      facility_name: this.facility_name ? this.facility_name : '',
      cse_name: this.cse_name ? this.cse_name : '',
      state_name: this.state_name ? this.state_name : '',
      payment_status_params: this.payment_status_params ? this.payment_status_params : '',
      lead_dr_name: this.lead_dr_name ? this.lead_dr_name : '',
    }

    this.filterParams.emit(filterValue);
  }

}
